import * as React from "react"
import { App } from "./app"
import { PADebug } from "./PADebug"


///////////////   LogView  ////////////////

/* LogView displays debug information from using the PADebug methods. */

export interface LogViewVm  {
    app: App
}

export interface LogViewStateVm {
    stage: string
}

export class LogView extends React.Component<LogViewVm, LogViewStateVm> {

    constructor(props: LogViewVm) {
        super(props)
    }
    
    state = {
        stage: "initial"
    }

    // 
    componentWillMount() {
        this.props.app.GetCore().ConnectLogView(this)
    }

    OnClickTitle() {
        PADebug.ResetLog()
        this.forceUpdate()
    }
    
    // 
    render() {
        var elements: Array<JSX.Element> = new Array<JSX.Element>()

        var loggRows = PADebug.GetLog()

        for (var i = 0; i < loggRows.length; i++) {
            
            const usedColor = loggRows[i].color
            var margin = 35 + (loggRows[i].tabs * 26)
            const margo = margin.toString() + "px"

            elements.push(
                <div key={this.props.app.GetCore().GetUniqueKey()} style={{ color: usedColor, marginLeft: margo, height:"21px" }} >{loggRows[i].message}
                </div>
            )
        }

        return (
            <div>
                {/* Title: */}
                < div onClick={this.OnClickTitle.bind(this)} style={{ height: "52px", fontSize: "26px", fontWeight: "bold", marginLeft: "35px", marginTop: "35px" }}>Prisassistenten logg:</div >
                {elements}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./client/view/LogView.tsx